import React, { useState, useEffect } from "react"; // ,{ useState, useEffect }
import { Layout, Button, Form, Input, message, Divider } from "antd";
import { loginbgF, loginbgS } from "../../../assets/index";
import FooterComponent from "../../appLayout/footer/FooterComponent";
import "./login.scss";
import { LABEL } from "../../../common/constants/label";
import { useNavigate } from "react-router-dom";
import Actions from "../../../redux/actions";
import idLogo from "../../../assets/idLogo.png";
import { getEnv } from "../../../enviroment";
import epmslogo from "../../../assets/epmslogo.png";
import axios from 'axios';
import { CONSTANTS, MetaTitle } from "../../../common/constants/constants";
import Meta from "../../../Meta";
const { ping } = getEnv();

const Login = () => {
  const [loader, setloader] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [pingsubmit, setPingsubmit] = useState(false);
  const [pingToken, setPingToken] = useState();
  const [ip, setIP] = useState('');

  const unloadScrollBars = () => {
    document.documentElement.style.overflow = "hidden"; // firefox, chrome
    document.body.scroll = "no"; // ie only
  };

  useEffect( () => {
    getIp();
  }, [])

  // creating function to load ip address from the API
  const getIp = async () => {
    const res = await axios.get('https://api.ipify.org/?format=json');
    if (res) {
      setIP(res?.data?.ip);
    }
  }
  
  /**
   * PING AUTH LOGIN START
   */

  useEffect(() => {
    let checkToken = localStorage.getItem('pingAccessToken');
    if (checkToken !== null) {
      let pingToken = localStorage.getItem('pingAccessToken');
      setPingToken(pingToken);
    }
  }, []);

  useEffect(() => {
    if (pingToken !== undefined) {
      onSubmitWithPing(localStorage.getItem('pingAccessToken'));
    }
  }, [pingToken]);

  const onSubmitWithPing = async (values) => {
    setPingsubmit(true);
    try {
      let data = {
        authToken: values.split("&token_type=")[0],
        ip : ip
      };
      let loginResponse = await Actions.userlogin(data);
      setPingsubmit(false);
      if (loginResponse && loginResponse.success) {
        var getUrl = loginResponse.data.data.privileges.filter((value) =>value.privilege===true);
        let checkDashboardPrivilege = getUrl.filter((item) => item.type == CONSTANTS.EMPLOYEE_MASTER_DASHBOARD);
        navigate("/employee-master/snapshot");
        // if(checkDashboardPrivilege[0]?.privilege){
        //   navigate("/employee-master/dashboard");
        // } else {
        //   navigate("/employee-master/snapshot");
        // }
      } else {
        message.error(loginResponse.data.message);
        setloader(false);
      }
    } catch (error) {
      message.error("Login failed");
    }
  }
  // ping login method
  const authViaPing = async () => {
    setPingsubmit(true);
    window.open(
      `https://sso.connect.pingidentity.com/sso/as/authorization.oauth2?client_id=${ping.client_id
      }&scope=openid%20profile%20email&nonce=${randomString()}&redirect_uri=${ping.redirect_uri
      }&response_type=token`,
      "_self"
    );
  };

  // random string for ping authentication
  function randomString() {
    var text = '';
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < 32; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }
  /**
   * PING AUTH LOGIN END
   */

  const layout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 12,
    },
  };
  const onFinish = async (values) => {
    if (
      values.username === "demo@taskus.com" &&
      values.password === "password"
    ) {
      localStorage.setItem("User", JSON.stringify(values));
      navigate("/employee-master/dashboard");
    } else {
      setloader(true);
      let data = {
        userName: values.username,
        userPassword: values.password,
        ip : ip
      };
      let response = await Actions.userlogin(data);
      if (response && response.success) {
        var getUrl = response.data.data.privileges.filter((value) =>value.privilege===true);
        let checkDashboardPrivilege = getUrl.filter((item) => item.type == CONSTANTS.EMPLOYEE_MASTER_DASHBOARD);
        navigate("/employee-master/snapshot");
        // if(checkDashboardPrivilege[0]?.privilege){
        //   navigate("/employee-master/dashboard");
        // } else {
        //   navigate("/employee-master/snapshot");
        // }
        setloader(false);
      } else {
        message.error(response.data.message);
        setloader(false);
      }
    }
  };
  return (
    <>
    <Meta name={MetaTitle.Login} />
    <Layout.Content>
      {unloadScrollBars()}
      <div className="login-pagebg">
        <img src={loginbgF} alt="" />
        <div className="login-section">
          <div>
            <div className="logo-box">
              <img className="logo-img" src={epmslogo} alt="" />
            </div>
            <Button
              onClick={async () => {
                authViaPing();
              }}
              loading={pingsubmit}
              style={{
                padding: "0px 10px",
                height: "47px",
                background: "#BC1C24",
                boxShadow:
                  "0px 0px 1.55851px rgba(0, 0, 0, 0.14), 3.11703px 3.11703px 8.57183px rgba(0, 0, 0, 0.06)",
                borderRadius: "3.89628px",
                margin: "29.1802px 0px",
                fontFamily: "'Poppins', sans-serif",
                fontWeight: "500",
                fontSize: "17px",
                lineHeight: "28px",
                letterSpacing: "0.116944px",
                color: "#FFFFFF",
                cursor: 'pointer'
              }}
            >
              {LABEL.SIGNIN_WITH_PING}
              <img
                style={{
                  marginLeft: "4px",
                  height: "22px",
                  width: "22px",
                  position: "inherit",
                }}
                src={idLogo}
                alt=""
              />
            </Button>
            {/*  <Divider plain>OR</Divider>
            <Form
              layout="vertical"
              name="basic"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              onFinish={onFinish}
              autoComplete="off"
            >
              <Form.Item
                label="Username"
                name="username"
                rules={[
                  { required: true, message: "Please input your username!" },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Password"
                name="password"
                rules={[
                  { required: true, message: "Please input your password!" },
                ]}
              >
                <Input.Password />
              </Form.Item>

              <Form.Item wrapperCol={{ span: 24 }}>
                <Button loading={loader} type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Form> */}
          </div>
        </div>
        <img src={loginbgS} alt="" />
      </div>
      <FooterComponent></FooterComponent>
    </Layout.Content>
    </>
  );
};

export default Login;
